import { useState } from 'react'
import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Textarea } from '@wartek-id/textarea'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import styles from 'app/KinerjaKSPage/pages/Perencanaan/TabRangkuman/components/DialogFinalizeSKP/DialogFinalizeSKP.module.css'

interface DialogFinalizeSKPProps extends Omit<DialogProps, 'children'> {
  isFinalizing?: boolean
  onClickFinalize?: () => any
  onClickCancel?: () => any
  ekinEligible?: boolean
}

const DialogFinalizeSKP = ({
  isFinalizing,
  onClickFinalize = () => {},
  onClickCancel = () => {},
  ekinEligible = false,
  ...props
}: DialogFinalizeSKPProps) => {
  const [textConsent, setTextConsent] = useState('')
  const consentScript =
    'Saya menyatakan bahwa saya menyetujui untuk mengumpulkan perencanaan dan isinya sudah sesuai.'
  const submitConsent = textConsent === consentScript
  const isConsentDirty = textConsent !== ''
  const isConsentFieldInvalid = !submitConsent && isConsentDirty
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent className={styles.wiggle}>
        <DialogCloseButton data-testid="btn-close" />
        <div className="mt-12 p-6">
          <Image
            alt="warning"
            src="/illustrations/img-warning.png"
            width={84}
            height={84}
            unoptimized={true}
          />
          <Text variant="display-sm" className="mt-4">
            Setelah dikumpulkan, perencanaan akan otomatis disetujui dan tidak
            dapat diubah lagi
          </Text>

          <span className="mt-4 p-4 rounded border border-gray-30 bg-gray-5 flex flex-col gap-2">
            <div className="flex gap-20">
              <Text variant="body-sm" color="subdued">
                Perencanaan akan disampaikan ke:
              </Text>
              <Text variant="body-sm">Kepala Dinas Pendidikan</Text>
            </div>
            {ekinEligible && (
              <Text variant="body-sm-bold">
                Data Perencanaan Kinerja Anda juga akan otomatis dialirkan ke
                E-Kinerja.
              </Text>
            )}
          </span>

          <Text variant="body-lg" className="mt-4">
            Mohon ketik kalimat ini ke kolom kalimat persetujuan:
          </Text>

          <span className="bg-blue-5 mt-4 p-4 rounded flex">
            <Text className="select-none">{consentScript}</Text>
          </span>

          <Text className="mt-4 mb-1">Kalimat persetujuan</Text>
          <Textarea
            rows={3}
            placeholder="Ketik di sini"
            id="persetujuan"
            onChange={(event) => {
              setTextConsent(event.target.value)
            }}
            isInvalid={isConsentFieldInvalid}
            errorMessage={
              isConsentFieldInvalid && 'Mohon cek ejaan dan coba lagi.'
            }
          />
          <div className="flex gap-5 mt-5">
            <Button
              size="lg"
              className="w-[190px]"
              disabled={isFinalizing || !submitConsent}
              isLoading={isFinalizing}
              onClick={() => onClickFinalize()}
              data-testid="btn-confirm"
            >
              Kumpulkan
            </Button>
            <Button
              size="lg"
              color="white"
              disabled={isFinalizing}
              isLoading={isFinalizing}
              onClick={() => onClickCancel()}
              data-testid="btn-cancel"
            >
              Cek ulang
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogFinalizeSKP
